import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#000000',
          secondary: '#025bbf',
          accent: '#025bbf',
          error: '#b71c1c',
          info: '#025bbf',
          blue: '#335c39',
        },
      },
    },
});
